import { render, staticRenderFns } from "./RunTiles.vue?vue&type=template&id=5a85d657&scoped=true&"
import script from "./RunTiles.vue?vue&type=script&lang=ts&"
export * from "./RunTiles.vue?vue&type=script&lang=ts&"
import style0 from "./RunTiles.vue?vue&type=style&index=0&id=5a85d657&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85d657",
  null
  
)

export default component.exports